import { render, staticRenderFns } from "./OnboardingConsent.vue?vue&type=template&id=6ec380ba&scoped=true&"
import script from "./OnboardingConsent.vue?vue&type=script&lang=js&"
export * from "./OnboardingConsent.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingConsent.vue?vue&type=style&index=0&id=6ec380ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec380ba",
  null
  
)

export default component.exports